import { render, staticRenderFns } from "./FieldSelect.vue?vue&type=template&id=4987067a&"
import script from "./FieldSelect.vue?vue&type=script&lang=js&"
export * from "./FieldSelect.vue?vue&type=script&lang=js&"
import style0 from "./FieldSelect.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports